// @flow

import $ from 'jquery'

import Util from '../util/Util'

export default class Input {
  static init () {
    $(document).on('input', '.input-numeric', event => {
      event.target.value = Util.getNumberString(event.target.value)
    })

    $(document).on('input', '.input-numeric-separated', event => {
      const newValue = Util.getSeparatedNumberString(event.target.value)

      if (event.target.value !== newValue) {
        event.target.value = newValue

        // this is bad practice and dangerous but Safari needs it ...
        $(event.target).trigger('change')
      }
    })
  }
}
